import type { IconAsset } from '../Icon.types';

const code = (
  <g transform='translate(-133 -1138)'>
    <rect fill='none' height='18' transform='translate(133 1138)' width='18' />
    <g transform='translate(137 1141)'>
      <path
        d='M10.667,3.067,10.133,2A14.532,14.532,0,0,0,3.2,6.267l-2.133-1.6L0,5.733,3.2,10A18.159,18.159,0,0,1,10.667,3.067Z'
        fill='currentColor'
      />
    </g>
  </g>
);

export const check: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
